/** Push-to-talk key. Space, always. Not configurable. */
export const PTT_PUSH_TO_TALK_KEY = " ";

/** Whisper initial-prompt vocabulary until GET /voice/stt-vocabulary ships. */
export const PTT_STT_PROMPT =
  "ORM board WX AMOPS TOWER RAPCON RAWS. SOF Supervisor of Flying. Statute miles visibility.";

export const PTT_AWS_SAMPLE_RATE_HZ = 16_000;
